module.exports = __webpack_public_path__ + "img/gloves.02acaf13.jpeg";